import React, { useState } from "react";
import Td from "../../common/table/td";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import NumberFormat from "react-number-format";
import Row from "../../common/layout/row";
import { IndicadoresFator } from "./IndicadoresFator";
import { IndicadorDemandasAtingidasUltrapassagem } from "./IndicadorDemandasAtingidasUltrapassagem";
import { TooltipAgendamento } from "./TooltipAgendamento";
import { TooltipPeriodoTeste } from "./TooltipPeriodoTeste";
import Button from "../../common/button/button";
import AlertIcon from "../../common/alertIcon/alertIcon";
import { TabelaDemandasMedidas } from "./TabelaDemandasMedidas";
import { TabelaDemandaContratada } from "./TabelaDemandaContratada";
import ampulhetaCirculo from "../../assets/images/ampulheta_circulo.png";
import Tr from "../../common/table/tr";
import DateFormat from "../../common/dateFormat/DateFormat";
import { calcularFatorPotencia } from "../../core/calcularFatorPotencia";
import { IndicadorLeiturasFaltando } from "./IndicadorLeiturasFaltando";
import { bindActionCreators } from "redux";
import { getListaGraficoDia, getMonitoramentoConsumo, setModoTela, setStatusVisualizado } from "../monitoramentoConsumoActions";
import { setPeriodoTesteVisualizado } from "../../demandaContrato/demandaContratoActions";
import { connect } from "react-redux";

function LinhaMonitoramentoConsumoComponent(props) {
    // Estado local para manter kvar_ind_simulado
    const [kvarIndSimulado, setKvarIndSimulado] = useState(props.item.consumoLeitura.kvar_ind_simulado || 0);
    // Quando estiver piscando e clicar no OK
    const [visualizadoFP, setVisualizadoFP] = useState(props.item.consumoLeitura.status_visualizado_fp || false);
    // sem id significa que não tem contrato de demanda, então exibe uma mensagem e oculta os dados de demanda
    const sazonalidadeDiferenteDaUC = props.item.id && props.item.contrato_demanda_sazonal != props.item.sazonal;

    const horosazonalVerde = props.item.id_modalidade_tarifaria == 1;
    const horosazonalAzul = props.item.id_modalidade_tarifaria == 2;
    const corTabelaDemanda = horosazonalVerde ? "#00d85f" : horosazonalAzul ? "#34cbff" : "#ddd";

    // Se houver reativo capacitivo, mantém o kvar_cap negativo; senão, usa o kvar_ind positivo

      const q =
          parseFloat(props.item.consumoLeitura.kvar_cap) < 0
              ? parseFloat(props.item.consumoLeitura.kvar_cap)
              : parseFloat(props.item.consumoLeitura.kvar_ind) > 0
              ? parseFloat(props.item.consumoLeitura.kvar_ind)
              : 0;

    const fatorPotencia = calcularFatorPotencia({
        p: props.item.consumoLeitura.kw,
        q,
    });

    const fatorPotenciaSimulado = calcularFatorPotencia({
        p: props.item.consumoLeitura.kw,
        q: kvarIndSimulado,
    });

    //define se está online ou offline ---------------------------------------------
    const dataHoraLeitura = new Date(props.item.consumoLeitura.data_hora);
    const dataHoraAtualValidacaoRecente = new Date();
    dataHoraAtualValidacaoRecente.setMinutes(dataHoraAtualValidacaoRecente.getMinutes() - 60);
    const onlineRecentemente = dataHoraLeitura >= dataHoraAtualValidacaoRecente;

    let exibirAlertaPkwVermelho = false;
    let exibirAlertaPkwVerde = false;

    //1 fora ponta e 2 ponta
    if (props.filtro.id_tipo_contrato_demanda == 1) {
        exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
        exibirAlertaPkwVerde =
            parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) &&
            parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
    } else if (props.filtro.id_tipo_contrato_demanda == 2) {
        exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
        exibirAlertaPkwVerde =
            parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_ponta_contratada_mes_atual) &&
            parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
    }

    const valorQAlterado = parseFloat(q) && kvarIndSimulado && kvarIndSimulado !== parseFloat(q);

    const grupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "GA - Med. BT"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "GA - Med. MT"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "GB - Med. BT"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "GB - Med. MT"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "GA/FB - Med. BT"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "GA/FB - Med. MT"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "GA/FA - Med. BT"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "GA/FA - Med. MT"
                          : "INDEFINIDO";

    const titleGrupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "Grupo A com medição de Baixa Tensão"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "Grupo A com medição de Média Tensão"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "Grupo B com medição de Baixa Tensão"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "Grupo B com medição de Média Tensão"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "Grupo A/Faturado em B com medição de Baixa Tensão"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "Grupo A/Faturado em B com medição de Média Tensão"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "Grupo A/Faturado em A com medição de Baixa Tensão"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "Grupo A/Faturado em A com medição de Média Tensão"
                          : "INDEFINIDO";

    const highlightAlert =
        window.innerWidth < 768 &&
        (!onlineRecentemente ||
            exibirAlertaPkwVermelho ||
            fatorPotencia < 0.92 ||
            props.item.consumoLeitura.cor_demanda_ponta === props.COR_ULTRAPASSAGEM ||
            props.item.consumoLeitura.cor_demanda_fora_ponta === props.COR_ULTRAPASSAGEM ||
            props.item.consumoLeitura.cor_demanda_reservado === props.COR_ULTRAPASSAGEM ||
            props.item.consumoLeitura.cor_demanda_geracao === props.COR_ULTRAPASSAGEM);

    const primeiroItemHistorico = (props.item.historico || [])[0] || {};
    const ultimoRegistroEmAndamento = primeiroItemHistorico.status === "Em andamento" || primeiroItemHistorico.status === "Iniciada";

    const estiloCelulaTensaoCorrente = {
        border: `1px solid #ccc`,
        padding: "2px 5px",
        textAlign: "center",
        minWidth: 60,
        textWrap: "nowrap",
        fontSize: "0.8rem",
    };

    const corVermelha = "#ff3164";
    const corVerde = "#15b85b";
    return (
        <>
            <Tr className={highlightAlert ? "animacao-alerta" : ""} key={props.item.id_unidade_consumdidora}>
                <Td>
                    <IndicadorDemandasAtingidasUltrapassagem
                        titleGrupoFaturamentoTipoMedicao={titleGrupoFaturamentoTipoMedicao}
                        grupoFaturamentoTipoMedicao={grupoFaturamentoTipoMedicao}
                        ultimaLinha={props.ultimaLinha}
                        item={props.item}
                        sazonalidadeDiferenteDaUC={sazonalidadeDiferenteDaUC}
                    />
                </Td>
                <Td color="#fff" alignCenter fontSize="0.65rem">
                    <IndicadoresFator sazonalidadeDiferenteDaUC={sazonalidadeDiferenteDaUC} item={props.item} />
                </Td>
                {props.usuarioLogado.administrador ? (
                    <Td minWidth={140} title={props.item.nome_cliente}>
                        <div>{props.item.nome_cliente.length > 45 ? props.item.nome_cliente.substring(0, 45) + "..." : props.item.nome_cliente}</div>
                        {props.item.consumoLeitura.nome_tipo_integracao ? (
                            <div
                                className={`px-3 py-1 ${props.item.consumoLeitura.nome_tipo_integracao !== "Gradios" ? "bg-dark" : "bg-blue"} text-white d-inline-block`}
                                style={{ borderRadius: "5px" }}
                            >
                                {props.item.consumoLeitura.nome_tipo_integracao}
                            </div>
                        ) : null}
                    </Td>
                ) : null}
                <Td minWidth={160} title={props.item.nome_unidade_consumidora}>
                    {props.item.nome_unidade_consumidora}
                    <div className="d-flex align-items-center" style={{ position: "relative", marginTop: 10 }}>
                        <div
                            style={{
                                position: "absolute",
                                left: 5,
                                top: -2,
                                fontSize: "1rem",
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            <i className="fas fa-wifi"></i>
                        </div>
                        {!onlineRecentemente && (
                            <div
                                style={{
                                    position: "absolute",
                                    left: 5,
                                    top: -2,
                                    fontSize: "1rem",
                                    color: corVermelha,
                                }}
                            >
                                <i className="fas fa-slash"></i>
                            </div>
                        )}
                        <span
                            style={{
                                fontSize: "0.7rem",
                                paddingTop: 18,
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            {onlineRecentemente ? <b>online</b> : <b>offline</b>}
                        </span>
                        {props.item.consumoLeitura.data_hora ? (
                            <div style={{ paddingLeft: 12, fontSize: "0.8rem" }}>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.data_hora)}</div>
                        ) : (
                            "-"
                        )}
                    </div>
                    {sazonalidadeDiferenteDaUC ? (
                        <div
                            style={{
                                backgroundColor: "#fd5959",
                                color: "#ffffff",
                                padding: 5,
                                borderRadius: "0.3rem",
                                textAlign: "center",
                            }}
                        >
                            <div style={{ width: "100%", minWidth: 150 }}>
                                <div>A sazonalidade da UC é diferente do contrato</div>
                                <div>
                                    (UC:{props.item.contrato_demanda_sazonal ? " Sazonal " : " Não Sazonal "} - Contrato:
                                    {props.item.sazonal ? " Sazonal " : " Não Sazonal "})
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex">
                            <TooltipAgendamento item={props.item} />
                            <TooltipPeriodoTeste
                                setPeriodoTesteVisualizado={props.setPeriodoTesteVisualizado}
                                getMonitoramentoConsumo={props.getMonitoramentoConsumo}
                                item={props.item}
                            />
                        </div>
                    )}
                </Td>

                <Td alignCenter minWidth={80}>
                    <Button
                        style={{ width: 80, height: 80, margin: 0 }}
                        title="Ver o gráfico do dia"
                        text={
                            <div>
                                <div>
                                    <i style={{ fontSize: "2rem" }} className="fas fa-chart-line"></i>
                                </div>
                                <b>P e Q</b>
                            </div>
                        }
                        type={"info"}
                        event={() => {
                            props.getListaGraficoDia({
                                id_consumo_integracao: props.item.consumoLeitura.id_consumo_integracao,
                                dataInicial: props.dataInicialGrafico,
                                dataFinal: props.dataFinalGrafico,
                            });
                            props.setModoTela("graficoDia", props.item);
                        }}
                    />
                    <IndicadorLeiturasFaltando item={props.item} visible={props.usuarioLogado.administrador} />
                </Td>
                <Td alignCenter fontSize="1rem">
                    <div
                        title={
                            props.item.consumoLeitura.potencia_ativa_a || props.item.consumoLeitura.potencia_ativa_b || props.item.consumoLeitura.potencia_ativa_c
                                ? `(Potência Ativa A: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_ativa_a)}, Potência Ativa B: ${adicionarPontosMilhar(
                                      props.item.consumoLeitura.potencia_ativa_b
                                  )}, Potência Ativa C: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_ativa_c)}) multiplicadas pela constante do medidor`
                                : "P(kW) multiplicado pela constante do medidor"
                        }
                        style={{
                            lineHeight: "1.1rem",
                            color: exibirAlertaPkwVermelho ? corVermelha : exibirAlertaPkwVerde ? corVerde : null,
                        }}
                    >
                        {exibirAlertaPkwVermelho && (
                            <AlertIcon
                                animationClass={props.item.consumoLeitura.status_visualizado_kw ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                title="A demanda medida em kW está igual ou superior à contratada"
                                event={() => {
                                    if (window.confirm('A demanda medida em kW está igual ou superior à contratada, deseja marcar alerta como "visualizado"?')) {
                                        props.setStatusVisualizado({
                                            id: props.item.consumoLeitura.id,
                                            coluna: "status_visualizado_kw",
                                        });
                                        props.item.consumoLeitura.status_visualizado_kw = true;
                                    }
                                }}
                            />
                        )}
                        <div
                            style={{
                                padding: exibirAlertaPkwVermelho ? "2px 2px 12px 2px" : "17px 2px 2px 2px",
                            }}
                        >
                            {!isNaN(parseFloat(props.item.consumoLeitura.kw)) ? <b>{adicionarPontosMilhar(props.item.consumoLeitura.kw)}</b> : "-"}
                        </div>
                    </div>
                </Td>
                <Td alignCenter fontSize="1rem">
                    <div
                        title={
                            props.item.consumoLeitura.potencia_reativa_a || props.item.consumoLeitura.potencia_reativa_b || props.item.consumoLeitura.potencia_reativa_c
                                ? `(Potência Reativa A: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_reativa_a)}, Potência Reativa B: ${adicionarPontosMilhar(
                                      props.item.consumoLeitura.potencia_reativa_b
                                  )}, Potência Reativa C: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_reativa_c)}) multiplicadas pela constante do medidor`
                                : "Q(kVAr) multiplicado pela constante do medidor"
                        }
                        style={{
                            position: "relative",
                            padding: "17px 2px 2px 2px",
                            textDecoration: valorQAlterado ? "line-through" : "none",
                        }}
                    >
                        {valorQAlterado ? <i className="fas fa-arrow-down display-6" style={{ position: "absolute", left: "40%", top: 34, color: "#25f655" }} /> : null}
                        {!isNaN(parseFloat(q)) ? adicionarPontosMilhar(q) : "-"}
                    </div>
                    {valorQAlterado ? <div>{adicionarPontosMilhar(kvarIndSimulado)}</div> : null}
                </Td>
                <Td alignCenter title="S = Raiz Quadrada de (P² + Q²)" fontSize="1rem">
                    <div style={{ padding: "17px 2px 2px 2px" }}>
                        {!isNaN(parseFloat(props.item.consumoLeitura.kw)) && !isNaN(parseFloat(q))
                            ? adicionarPontosMilhar(Math.sqrt(Math.pow(parseFloat(props.item.consumoLeitura.kw), 2) + Math.pow(parseFloat(q), 2)))
                            : "-"}
                    </div>
                </Td>
                <Td alignCenter fontSize="1rem">
                    <table>
                        <tbody>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>A</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_a) || "-"}</td>
                            </tr>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>B</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_b) || "-"}</td>
                            </tr>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>C</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_c) || "-"}</td>
                            </tr>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>N</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.corrente_secundaria_n) || "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                </Td>
                <Td alignCenter fontSize="1rem">
                    <table>
                        <tbody>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>A</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_a) || "-"}</td>
                            </tr>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>B</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_b) || "-"}</td>
                            </tr>
                            <tr>
                                <td style={estiloCelulaTensaoCorrente}>C</td>
                                <td style={estiloCelulaTensaoCorrente}>{adicionarPontosMilhar(props.item.consumoLeitura.tensao_secundaria_c) || "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                </Td>
                <Td alignCenter fontSize="1rem">
                    {!isNaN(fatorPotencia) ? (
                        <div
                            style={{
                                lineHeight: "1.1rem",
                                color: fatorPotencia < 0.92 ? corVermelha : corVerde,
                            }}
                        >
                            {fatorPotencia < 0.92 && (
                                <AlertIcon
                                    animationClass={visualizadoFP ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                    title="FP está abaixo de 0,92"
                                    event={() => {
                                        if (window.confirm('FP está abaixo de 0,92, deseja marcar alerta como "visualizado"?')) {
                                            setVisualizadoFP(true);
                                            props.setStatusVisualizado({
                                                id: props.item.consumoLeitura.id,
                                                coluna: "status_visualizado_fp",
                                            });
                                            // props.item.consumoLeitura.status_visualizado_fp = true;
                                        }
                                    }}
                                />
                            )}
                            <div
                                style={{
                                    padding: fatorPotencia < 0.92 ? "2px 2px 12px 2px" : "17px 2px 2px 2px",
                                }}
                            >
                                <b title="FP = P / S">{adicionarPontosMilhar(fatorPotencia)}</b>
                            </div>
                        </div>
                    ) : (
                        "-"
                    )}
                </Td>
                <Td alignCenter>
                    <TabelaDemandasMedidas
                        corTabelaDemanda={corTabelaDemanda}
                        COR_ULTRAPASSAGEM={props.COR_ULTRAPASSAGEM}
                        horosazonalAzul={horosazonalAzul}
                        horosazonalVerde={horosazonalVerde}
                        setStatusVisualizado={props.setStatusVisualizado}
                        item={props.item}
                    />
                </Td>
                <Td alignCenter>
                    <div className="d-flex justify-content-center align-items-center">
                        <div>
                            <TabelaDemandaContratada corTabelaDemanda={corTabelaDemanda} item={props.item} />
                        </div>
                        <div>
                            <Button
                                title={ultimoRegistroEmAndamento ? "Existe um ajuste de demanda em andamento" : "Histórico"}
                                style={{ width: 180, margin: "0px 5px 3px", padding: "3px 3px" }}
                                text={<span>Histórico {ultimoRegistroEmAndamento ? <img height={20} width={20} src={ampulhetaCirculo} alt="" /> : null}</span>}
                                type={"brown"}
                                icon={"fas fa-book"}
                                visible={true}
                                disabled={!(props.item.historico || []).length}
                                event={() => {
                                    props.setExibirModalHistorico(true);
                                    props.setItemSelecionado(props.item);
                                }}
                            />

                            <Button
                                style={{ width: 180, margin: "4px 8px 3px", padding: "3px 3px" }}
                                text="Análise de Demanda Contratada"
                                type={"purple"}
                                icon={"fas fa-chart-bar"}
                                visible={true}
                                disabled={!props.item.id}
                                event={() => {
                                    const ucCompleta = props.listaUnidadeConsumidora.find((uc) => uc.id === props.item.id_unidade_consumidora) || {};
                                    props.setExibirModalAnaliseDemandaContratada(true);
                                    props.setItemSelecionado({ ...props.item, id_cliente: ucCompleta.id_cliente });
                                }}
                            />
                        </div>
                    </div>
                </Td>
            </Tr>
            <Tr key={props.item.id + "-simulado"} style={{ backgroundColor: "#f4f4f4" }}>
                <Td colSpan={2} style={{ borderTop: "none" }}>
                    <div className="d-flex pl-2">
                        <i className="fas fa-level-up-alt" style={{ transform: "rotate(90deg)", fontSize: "1.2rem" }}></i>
                        <div className="pl-4">
                            <b>Simular banco de capacitor</b>
                        </div>
                    </div>
                </Td>
                <Td alignCenter colSpan={props.usuarioLogado.administrador ? 4 : 3} style={{ borderTop: "none" }}>
                    <div className="d-flex align-items-center">
                        <div style={{ width: "100%", height: 2, backgroundColor: "#24c3de" }}></div>
                        {!props.loading && <div style={{ height: 10, width: 10, borderRadius: "100%", border: "2px solid #24c3de" }}></div>}
                    </div>
                </Td>
                <Td alignCenter style={{ borderTop: "none" }}></Td>
                <Td alignCenter fontSize="1rem" style={{ borderTop: "none" }}>
                    {!isNaN(parseFloat(q)) ? (
                        <Row style={{ width: 90, paddingInline: 5, justifyContent: "center" }}>
                            <NumberFormat
                                className="form-control"
                                placeholder="simular"
                                decimalSeparator={","}
                                decimalScale={2}
                                fixedDecimalScale={2}
                                allowNegative={true}
                                onChange={(e) => {
                                    const valorFormatado = parseFloat(e.target.value.replace(",", ".")) || 0;
                                    setKvarIndSimulado(q - valorFormatado);
                                }}
                            />
                        </Row>
                    ) : (
                        "-"
                    )}
                </Td>
                <Td alignCenter colSpan={3} style={{ borderTop: "none" }}>
                    {valorQAlterado ? (
                        <div className="d-flex align-items-center justify-content-center">
                            <div style={{ width: "70%", height: 2, backgroundColor: "#25f655" }}></div>
                            <div style={{ color: "#25f655" }}>
                                <i className="fas fa-arrow-right" />
                            </div>
                        </div>
                    ) : null}
                </Td>

                <Td alignCenter style={{ borderTop: "none" }}>
                    {!valorQAlterado || isNaN(fatorPotenciaSimulado) ? (
                        " - "
                    ) : (
                        <div className="d-flex align-items-center">
                            <i
                                style={{ color: fatorPotenciaSimulado < 0.92 ? corVermelha : corVerde }}
                                className={`fas fa-${fatorPotenciaSimulado < 0.92 ? "times" : "check"} mr-2`}
                            />
                            <div>
                                <span
                                    title={fatorPotenciaSimulado < 0.92 ? "Fator de potência ainda está abaixo, recomenda-se adicionar mais capacitores" : "Fator de potência Ok"}
                                >
                                    {adicionarPontosMilhar(fatorPotenciaSimulado)}
                                </span>
                            </div>
                        </div>
                    )}
                </Td>
                <Td alignCenter style={{ borderTop: "none" }}></Td>
                {/* <Td alignCenter minWidth={160} style={{ borderTop: "none" }}></Td> */}
                {/* {props.item.id && sazonalidadeDiferenteDaUC ? <Td alignCenter style={{ borderTop: "none" }}></Td> : null} */}
            </Tr>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        filtro: state.monitoramentoConsumo.filtro,
        listaUnidadeConsumidora: state.monitoramentoConsumo.listaUnidadeConsumidora,
        listaMonitoramentoConsumo: state.monitoramentoConsumo.listaMonitoramentoConsumo,
        dataInicialGrafico: state.monitoramentoConsumo.dataInicialGrafico,
        dataFinalGrafico: state.monitoramentoConsumo.dataFinalGrafico,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            getListaGraficoDia,
            getMonitoramentoConsumo,
            setStatusVisualizado,
            setPeriodoTesteVisualizado,
        },
        dispatch
    );
const LinhaMonitoramentoConsumo = connect(mapStateToProps, mapDispatchToProps)(LinhaMonitoramentoConsumoComponent);

export { LinhaMonitoramentoConsumo };
